import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {DxFormComponent} from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import {IDefaultSelectBoxViewModel} from '@shared/models/default-selectBox.model';
import {AjaxService} from 'AjaxService';
import {EntityArt} from '@enums/entityArt.enum';
import validationEngine from 'devextreme/ui/validation_engine';

interface IUeTlSaveItemExternViewModel {
  selected: IUeTlItemExternViewModel;
  all: IUeTlItemExternViewModel[];
}

interface IUeTlItemExternViewModel {
  antragBeId: number;
  mitarbeiterId: number;

  selectedMitarbeiterId: number;

  fullName: string;
  name: string;
  vorname: string;
  geburtsname: string;
  geburtsdatum?: Date;
  ausbildungIds: number[];
  ausbildungsOrte: string;
  erwFührZeug: boolean;
  erwFührZeugAustellungsDatum?: Date;
  erwFührZeugWithEintrag?: number;
  zeugUrkchecked: boolean;
  gesamtAnteil: number;
}

@Component({
    selector: 'aBe-e-mitA-popup',
    templateUrl: './aBe-e-mitA-popup.component.html',
    styleUrls: ['./aBe-e-mitA-popup.component.css'],
    standalone: false
})
export class AntragBeExternMitarbeiterPopupComponent {
  @ViewChild('mitAForm', {static: false}) mitAForm: DxFormComponent;

  loading: number = 1;
  error: boolean = false;

  minDate = new Date('1900/1/1');
  _nowDate: Date;
  get nowDate(): Date {
    if (!this._nowDate) {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      this._nowDate = d;
    }

    return this._nowDate;
  }

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseOk: EventEmitter<any> = new EventEmitter<any>();

  @Input() antragBeId: number;
  @Input() mitarbeiterId: number;

  @Input() selectedMitarbeiter: IUeTlItemExternViewModel;
  @Input() popupVisible: boolean;
  @Input() isEdit: boolean;
  @Input() withoutZeugnisCheck: boolean = true;

  availablAusbildungen: IDefaultSelectBoxViewModel[];
  availablMitarbeiter: IUeTlItemExternViewModel[] = [] as IUeTlItemExternViewModel[];

  fuehZeugItems = [
    {
      text: 'enthält keine Eintragung',
      value: 1,
    },
    {
      text: 'enthält Eintragungen',
      value: 2,
    },
  ];

  shadowMitarbeiter: IUeTlItemExternViewModel = {} as IUeTlItemExternViewModel;

  p: any = {};

  showAusbildungsort: boolean = false;
  infoLinkItems: any[];
  showAusbildungEditorInfoLink: boolean = false;
  showAusbildungEditorInfoLinkItem: any = {};

  constructor(private ajaxService: AjaxService) {
    this.dateValidationCallback = this.dateValidationCallback.bind(this);
    this.onClickUebernehmen = this.onClickUebernehmen.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.onAusbildungValueChanged = this.onAusbildungValueChanged.bind(this);
    this.hasToShowAusbildungsort = this.hasToShowAusbildungsort.bind(this);
  }

  dateValidationCallback(e) {
    const date = new Date(e.value);
    return date >= e.rule.min && date <= e.rule.max;
  }

  load() {
    this.loadingCount = 0;

    this.ajaxService.post<IUeTlItemExternViewModel[]>('api/ExternAntragBe/GetAvailableMitarbeiter', {antragBeId: this.antragBeId}).subscribe({
      next: (response) => {
        this.availablMitarbeiter = response;
        this.canStopLoading();
      },
      error: (e) => {
        this.error = true;
        this.stopLoading();
        throw e;
      },
    });

    this.ajaxService.post<IDefaultSelectBoxViewModel[]>('api/Options/GetEntityForSelectEdit', EntityArt.Ausbildung).subscribe({
      next: (response) => {
        this.availablAusbildungen = response;
        this.canStopLoading();
      },
      error: (e) => {
        this.error = true;
        this.stopLoading();
        throw e;
      },
    });
  }

  loadingCount = 0;
  canStopLoading() {
    this.loadingCount++;
    if (this.loadingCount >= 2) {
      this.stopLoading();
      this.hasToShowAusbildungsort(this.shadowMitarbeiter.ausbildungIds);
    }
  }

  onClickUebernehmen() {
    const validationResult = this.mitAForm.instance.validate();
    const validationResult_ausbildungenVg1 = validationEngine.validateGroup('ausbildungenVg1');

    if (!validationResult.isValid || !validationResult_ausbildungenVg1.isValid) {
      let msg = '';
      for (const err of validationResult.brokenRules) {
        msg += err.message + '\r\n';
      }

      for (const err of validationResult_ausbildungenVg1.brokenRules) {
        msg += err.message + '\r\n';
      }

      notify(
        {
          message: msg,
          width: 600,
        },
        'error',
        3000
      );
    } else {
      const exist = this.availablMitarbeiter.find((x) => x.name.trim().toLowerCase() === this.shadowMitarbeiter.name.trim().toLowerCase() && x.vorname.trim().toLowerCase() === this.shadowMitarbeiter.vorname.trim().toLowerCase());

      if (exist && !this.isEdit) {
        notify(
          {
            message: 'Mitarbeiter mit diesem Namen existiert bereits!',
            width: 600,
          },
          'error',
          3000
        );
      } else {
        this._set(this.shadowMitarbeiter, this.selectedMitarbeiter);

        if (!this.isEdit) {
          this.startLoading(2);
          this.ajaxService.post<IUeTlSaveItemExternViewModel>('api/ExternAntragBe/SetAddMitarbeiter', this.selectedMitarbeiter).subscribe({
            next: (response) => {
              this.availablMitarbeiter = response.all;
              this.popupVisible = false;
              this.onCloseOk.next(response);
              this.stopLoading();
            },
            error: (e) => {
              this.error = true;
              this.stopLoading();
              throw e;
            },
          });
        } else {
          this.startLoading(2);
          this.ajaxService.post<IUeTlSaveItemExternViewModel>('api/ExternAntragBe/SetUpdateMitarbeiter', this.selectedMitarbeiter).subscribe({
            next: (response) => {
              this.availablMitarbeiter = response.all;
              this.popupVisible = false;
              this.onCloseOk.next(response);
              this.stopLoading();
            },
            error: (e) => {
              this.error = true;
              this.stopLoading();
              throw e;
            },
          });
        }
      }
    }
  }

  onClickClose() {
    this.onClose.emit(null);
  }

  onShowingPopup(event) {
    this._set(this.selectedMitarbeiter, this.shadowMitarbeiter);
    this.load();
  }

  onHiddenPopup(event) {
    this.popupVisible = false;
    this.shadowMitarbeiter = {} as IUeTlItemExternViewModel;
  }

  private _set(source: IUeTlItemExternViewModel, target: IUeTlItemExternViewModel) {
    target.antragBeId = source.antragBeId;
    target.mitarbeiterId = source.mitarbeiterId;

    target.name = source.name;
    target.vorname = source.vorname;
    target.geburtsname = source.geburtsname;
    target.geburtsdatum = source.geburtsdatum;
    target.ausbildungIds = source.ausbildungIds;
    target.ausbildungsOrte = source.ausbildungsOrte;
    target.erwFührZeug = !source.erwFührZeug ? false : source.erwFührZeug;
    target.erwFührZeugAustellungsDatum = source.erwFührZeugAustellungsDatum;
    target.erwFührZeugWithEintrag = source.erwFührZeugWithEintrag;
    target.zeugUrkchecked = source.zeugUrkchecked;
  }

  startLoading(state: number) {
    this.loading = state;
  }

  stopLoading() {
    this.loading = 0;
  }

  //--- Ausbildungsort

  onAusbildungValueChanged(e) {
    if (e.event !== undefined && e.event !== null) {
      this.mitAForm.instance.option('formData.ausbildungIds', e.value);
      this.hasToShowAusbildungsort(e.value);
    }
  }

  hasToShowAusbildungsort(ids: number[]) {
    setTimeout(() => {
      if (ids === undefined || ids === null || ids.length < 1) {
        this.showAusbildungsort = false;
        if (this.mitAForm !== undefined && this.mitAForm !== null) {
          this.mitAForm.instance.option('formData.ausbildungsOrte', null);
        }
        return;
      }

      let showAusbildungsort = false;
      for (let index = 0; index < ids.length; index++) {
        const ausbId = ids[index];
        const exist = this.availablAusbildungen.find((x) => x.id === ausbId);
        if (exist !== undefined && exist !== null) {
          if (exist.param.askForAusbildungsort === true) {
            showAusbildungsort = true;
          }
        }
      }

      this.showAusbildungsort = showAusbildungsort;
      if (showAusbildungsort !== true && this.mitAForm !== undefined && this.mitAForm !== null) {
        this.mitAForm.instance.option('formData.ausbildungsOrte', null);
      }
    }, 0);
  }

  onClickInfoLink(e) {
    this.infoLinkItems = [];
    const ids = this.shadowMitarbeiter.ausbildungIds;
    if (ids !== undefined && ids !== null && ids.length > 0) {
      for (let index = 0; index < ids.length; index++) {
        const ausbId = ids[index];
        const exist = this.availablAusbildungen.find((x) => x.id === ausbId);
        if (exist !== undefined && exist !== null) {
          if (exist.param.infoLink !== undefined && exist.param.infoLink !== null && exist.param.infoLink.length > 0) {
            exist.param.infoLink = this.buildFullUrl(exist.param.infoLink);
            this.infoLinkItems.push(exist);
          }
        }
      }
    }

    this.showAusbildungEditorInfoLink = !this.showAusbildungEditorInfoLink;
  }

  buildFullUrl(url: string) {
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }

    return url;
  }

  get canShoInfoLink() {
    const ids = this.shadowMitarbeiter.ausbildungIds;
    if (ids !== undefined && ids !== null && ids.length > 0) {
      let result = false;
      for (let index = 0; index < ids.length; index++) {
        const ausbId = ids[index];
        const exist = this.availablAusbildungen.find((x) => x.id === ausbId);
        if (exist !== undefined && exist !== null) {
          if (exist.param.infoLink !== undefined && exist.param.infoLink !== null && exist.param.infoLink.length > 0) {
            result = true;
          } else {
            result = false;
          }
        } else {
          result = false;
        }

        if (result === true) {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  disablePopup(id) {
    setTimeout(() => {
      this.showAusbildungEditorInfoLinkItem[id] = false;
    }, 50);
  }
}
